import { render } from "./loginblock.vue?vue&type=template&id=3fbbfd82"
import script from "./loginblock.vue?vue&type=script&lang=js"
export * from "./loginblock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__